module.exports = __webpack_public_path__ + "img/header-weddingRingsMen.0953bbd.webp";